<script setup lang="ts">
import { ref, watch, type VNodeChild } from 'vue'
import { Filter } from '@lucide/vue'
import RrDropdown from '../dropdown/RrDropdown.vue'
import RrButton from '../button/RrButton.vue'
import RenderContent from '../internal/RenderContent'
import type { TableKey } from './types'

const props = withDefaults(defineProps<{ options: { text: VNodeChild; value: TableKey }[]; value?: TableKey[] | null; multiple?: boolean; title?: string; disabled?: boolean }>(), { multiple: true, disabled: false })
const emit = defineEmits<{ change: [values: TableKey[]] }>()
const open = ref(false)
const draft = ref<TableKey[]>([])
watch(open, value => { if (value) draft.value = [...(props.value ?? [])] })
function toggle(value: TableKey, checked: boolean) {
  draft.value = props.multiple ? checked ? [...draft.value, value] : draft.value.filter(item => item !== value) : checked ? [value] : []
}
function apply(values: TableKey[]) { emit('change', values); open.value = false }
</script>

<template>
  <RrDropdown v-model:open="open" :trigger="['click']" :disabled="disabled" placement="bottomRight">
    <button type="button" class="rr-table-filter__trigger" :class="{ 'is-active': value?.length }" :disabled="disabled" :aria-label="`筛选${title ?? '列'}`" :aria-expanded="open" @click.stop @keydown.stop><Filter :size="13" aria-hidden="true" /></button>
    <template #overlay>
      <div class="rr-table-filter" @click.stop @keydown.stop>
        <label v-for="option in options" :key="option.value" class="rr-table-filter__option">
          <input :type="multiple ? 'checkbox' : 'radio'" :checked="draft.includes(option.value)" @change="toggle(option.value, ($event.target as HTMLInputElement).checked)" />
          <RenderContent :value="option.text" />
        </label>
        <div class="rr-table-filter__actions"><RrButton size="small" type="text" @click="apply([])">重置</RrButton><RrButton size="small" type="primary" @click="apply(draft)">确定</RrButton></div>
      </div>
    </template>
  </RrDropdown>
</template>

<style scoped>
.rr-table-filter__trigger { display: inline-flex; align-items: center; justify-content: center; padding: var(--rr-space-1); border: 0; min-height: unset; background: transparent; color: var(--rr-color-text-muted); cursor: pointer; }
.rr-table-filter__trigger.is-active { color: var(--rr-color-primary); }
.rr-table-filter { display: grid; gap: var(--rr-space-2); padding: var(--rr-space-2); min-width: 140px; }
.rr-table-filter__option { display: flex; align-items: center; gap: var(--rr-space-2); color: var(--rr-color-text); cursor: pointer; }
.rr-table-filter__option input { width: 16px; height: 16px; min-height: 16px; margin: 0; padding: 0; }
.rr-table-filter__actions { display: flex; justify-content: space-between; gap: var(--rr-space-2); border-top: 1px solid var(--rr-color-border); padding-top: var(--rr-space-2); }
</style>
